<template>
  <div class="enroll-labels--content no-select">
    <div class="enroll-labels--container">
      <div class="date">
        <div v-if="showArrows" @click="prevDate" class="left cursor-pointer">
          <f-awesome icon="arrow-left"></f-awesome>
        </div>
        <div class="date-text">
          {{ datePhpToRus(date) }}
        </div>
        <div v-if="showArrows" @click="nextDate" class="right cursor-pointer">
          <f-awesome icon="arrow-right"></f-awesome>
        </div>
      </div>
      <div class="schedule-info">
        <div v-if="data.result == 'ok'">
          Рабочий день с {{ minuteToTime(schedule.time_from) }} до
          {{ minuteToTime(schedule.time_to) }}
        </div>
        <div v-if="data.result == 'error'">
          {{ data.text }}
        </div>
      </div>
      <div class="actions">
        <div v-if="!openEnroll" @click="openEnrollToggle" class=""><f-awesome icon="caret-down"></f-awesome> Развернуть все</div>
        <div v-if="openEnroll" @click="openEnrollToggle" class=""><f-awesome icon="caret-up"></f-awesome> Свернуть все</div>
      </div>
      <div v-if="data.result == 'ok'" class="labels">
        <div class="items" v-for="(item, index) in labels" :key="index">
          <div
            class="free item"
            v-bind:class="{ progress: item.progress === true }"
            v-if="item.type == 'free'"
          >
            <div class="head">
              <div @click="createEnroll(item.time_from)" v-if="checkPermission('create_enroll')" class="action">
                <div class="btn-sm-circle btn-info">
                  <f-awesome icon="plus"></f-awesome>
                </div>
              </div>
              <div class="text">
                Окно {{ minuteToTime(item.time_from) }} -
                {{ minuteToTime(item.time_to) }}
                <div class="duration_window">
                  ({{ getDurationWindow(item.time_from, item.time_to) }})
                </div>
              </div>
            </div>
          </div>
          <div class="break item" v-if="item.type == 'break'">
            Перерыв {{ minuteToTime(item.time_from) }} -
            {{ minuteToTime(item.time_to) }}
          </div>
          <div
            class="enroll item"
            v-bind:class="{
              new: item.confirm == 0,
              confirm: item.confirm == 1,
              done: item.confirm == 2,
              canceled: item.confirm == 3,
              progress: item.progress === true
            }"
            v-if="item.type == 'enroll'"
          >
            <div class="head">
              <div class="action" @click="slideEnroll(item.id)">
                <div v-if="item.show_more === true" class="btn-sm-circle">
                  <f-awesome icon="caret-up"></f-awesome>
                </div>
                <div v-if="item.show_more === false" class="btn-sm-circle">
                  <f-awesome icon="caret-down"></f-awesome>
                </div>
              </div>
              <div @click="updateEnroll(item.id, item.time_from)" class="text">
                {{ minuteToTime(item.time_from) }} -
                {{ minuteToTime(item.time_to) }}
              </div>
            </div>
            <div
              v-show="item.show_more === true"
              @click="updateEnroll(item.id, item.time_from)"
              class="more"
            >
              <div v-if="+item.is_group === 0" class="client_name">
                <span v-if="item.enrollClients[0].clientModification">
                  {{ item.enrollClients[0].clientModification.name }}
                </span>
                <span v-if="!item.enrollClients[0].clientModification">
                  {{ item.enrollClients[0].clients.name }} {{ item.enrollClients[0].clients.surname }}
                </span>
                <span v-if="item.enrollClients[0].clients.sale">(скидка {{item.enrollClients[0].clients.sale}}%) </span>
                <span v-if="+item.enrollClients[0].clients.is_unwanted === 1"><b>(нежелательный клиент!)</b></span>
              </div>
              <div v-if="+item.is_group === 1" class="client_name">
                <span class="text-bold">{{ calculateActiveGroupCount(item.enrollClients) }}</span> клиента (-ов) в групповой записи
              </div>
              <div v-if="+item.is_group === 0" class="client_number">{{  phoneNumberToMask(item.enrollClients[0].clients.number) }}</div>
              <div class="client_services">
                <span v-for="service in item.enrollPosition" :key="service.id"
                  >{{ service.service_name }}:
                </span>
              </div>
              <div v-if="+item.is_group === 0 && item.enrollClients && item.enrollClients[0].comment && +item.is_group === 0" class="client_comment mrg-t-5">
                Комментарий клиента: {{item.enrollClients[0].comment?item.enrollClients[0].comment:'-'}}
              </div>
              <div v-if="item.comments && item.comments.comment_company" class="company_comment mrg-t-5">
                Ваш комментарий: {{item.comments?item.comments.comment_company:'-'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <popup
      :closeButton="editEnrollPopup.closeButton"
      :show="editEnrollPopup.show"
      :size="editEnrollPopup.size"
      :backgroundColor="editEnrollPopup.backgroundColor"
      @closePopup="closeEditEnrollPopup"
    >
      <div slot="header">
        {{ editEnrollPopup.header }}
        <hints :type="'text'" :title="'Скидка клиента'">
          <div slot="text">
            Скидка будет автоматически применяться к стоимости каждой позиции.<br><br>
            <span class="text-orange">Внимание!</span> Если, создавая запись, вы сами подкорректировали стоимость
            какой-либо услуги, то к этим позициям скидка применяться не будет<br><br>
            Скидка применяется только в том случае, если на момент создания или редактирования записи стоимость
            позиции соответствует полной стоимости
          </div>
        </hints>
      </div>
      <div slot="body">
        <fast-new
          :show="editEnrollPopup.show"
          :staffId="schedule.staff_id"
          :default-date="fastNewDefaultDate"
          :want-time="wantTime"
          :loadEnrollId="selectedEnrollId"
          :mode="fastNewMode"
          @updateLoadEnroll="updateLoadEnroll"
          @updateWantTime="updateWantTime"
          @closeAndUpdate="closeAndUpdateFast"
          @close="closeFast"
        ></fast-new>
      </div>
    </popup>
  </div>
</template>

<script>
import Formatter from "../../libraries/Formatter";
import Popup from "../../Popup";
import FastNew from "./fast_new/FastNew";
import permissionMixin from "@/components/mixins/Permissions";
import Hints from "@/components/Hints";

const formatter = new Formatter();

export default {
  name: "EnrollLabels",
  components: {Hints, FastNew, Popup },
  mixins: [permissionMixin],
  data() {
    return {
      date: "",
      schedule: {},
      labels: [],
      intervalProgress: false,
      editEnrollPopup: {
        show: false,
        closeButton: 'Закрыть',
        size: "lg",
        header: "",
        backgroundColor: 'wgray'
      },
      selectedEnrollId: null,
      fastNewMode: "new",
      wantTime: 0,
      openEnroll: false, // Раскрытие ярлыком с записями
    };
  },
  props: {
    data: Object,
    show: Boolean,
    showArrows: Boolean, // Отображение стрелок переключения даты
  },
  watch: {
    data: function(val) {
      this.setLabelsData(val);
    },
    show: function(val) {
      if (val) {
        this.setProgress();
        this.intervalProgress = setInterval(this.setProgress, 2000);
      } else {
        clearInterval(this.intervalProgress);
      }
    }
  },
  computed: {
    fastNewDefaultDate() {
      let result = "";
      if (this.date != "") {
        result = formatter.phpDateToRus(this.date);
      }
      return result;
    },
  },
  methods: {
    calculateActiveGroupCount(data){
      let result = 0;
      for(let key in data){
        if(+data[key].is_canceled === 0){
            if(data[key].clients){
              result++;
            }
          }
      }
      return result;
    },
    prevDate(){
      let dateObj = formatter.rusDateToJSObject(this.fastNewDefaultDate);
      dateObj.setDate(dateObj.getDate() - 1);
      this.$emit('editDate', formatter.dateToPhpFormat(dateObj));
    },
    nextDate(){
      let dateObj = formatter.rusDateToJSObject(this.fastNewDefaultDate);
      dateObj.setDate(dateObj.getDate() + 1);
      this.$emit('editDate', formatter.dateToPhpFormat(dateObj));
    },
    phoneNumberToMask(number){
      return formatter.phoneNumberToMask(number);
    },
    closeAndUpdateFast() {
      this.closeEditEnrollPopup();
    },
    closeFast() {
      this.closeEditEnrollPopup();
    },
    updateWantTime(val) {
      this.wantTime = val;
    },
    updateLoadEnroll(val) {
      this.selectedEnrollId = val;
      this.fastNewMode = "edit";
    },
    closeEditEnrollPopup() {
      this.editEnrollPopup.show = false;
    },
    createEnroll(wantTime) {
      this.fastNewMode = "new";
      this.selectedEnrollId = 0; // Сбросим
      this.editEnrollPopup.show = true;
      this.wantTime = wantTime;
      this.editEnrollPopup.header = "Добавление записи";
    },
    updateEnroll(id, wantTime) {
      this.fastNewMode = "edit";
      this.editEnrollPopup.show = true;
      this.selectedEnrollId = +id;
      this.wantTime = wantTime;
      this.editEnrollPopup.header = "Изменение записи";
    },
    setLabelsData(data) {
      this.labels = data.response;
      this.date = data.date;
      if (typeof data.schedule !== "undefined") {
        this.schedule = data.schedule;
      }
      for (let key in this.labels) {
        this.$set(this.labels[key], "show_more", this.openEnroll);
        this.$set(this.labels[key], "progress", false);
      }
    },
    getDurationWindow(time_from, time_to) {
      let result = formatter.minuteSplitHumanHourMinute(time_to - time_from);
      return result;
    },
    minuteToTime(minutes) {
      return formatter.minuteToTime(minutes);
    },
    slideEnroll(id) {
      for (let key in this.labels) {
        if (+this.labels[key].id === +id) {
          this.$set(this.labels[key], "show_more", !this.labels[key].show_more);
        }
      }
    },
    datePhpToRus(date){
      if(!date){
        return '';
      }else{
        return formatter.phpDateToShortString(date);
      }
    },
    setProgress() {
      let nowDate = new Date();
      // Проверим дату. Если сегодня не совпадает с открытой датой, то завершим setInterval
      let openDate = formatter.phpDateToJSObject(this.date);
      let nowOnlyDate = formatter.paramsDateToJSObject(
        nowDate.getDate(),
        nowDate.getMonth(),
        nowDate.getFullYear()
      );
      if (openDate.getTime() !== nowOnlyDate.getTime()) {
        clearInterval(this.intervalProgress);
        return false;
      }
      let minutes = formatter.hourMinuteToMinute(
        nowDate.getHours(),
        nowDate.getMinutes()
      );
      for (let key in this.labels) {
        if (
          minutes >= +this.labels[key].time_from &&
          minutes < +this.labels[key].time_to
        ) {
          this.$set(this.labels[key], "progress", true);
        } else {
          this.$set(this.labels[key], "progress", false);
        }
      }
    },
    openEnrollInit(){
      let storage = localStorage.getItem("openEnroll");
      if(storage === null){
        localStorage.setItem("openEnroll", false);
      }else{
        this.openEnroll = formatter.boolStringToType(storage);
      }
    },
    openEnrollToggle(){
      let storage = localStorage.getItem("openEnroll");
      if(storage === null){
        // На всякий случай
        localStorage.setItem("openEnroll", false);
      }else{
        this.openEnroll = !this.openEnroll;
        localStorage.setItem("openEnroll", this.openEnroll);
        this.openEnrollAction(this.openEnroll);
      }
    },
    // Раскрывает или скрывает записи
    openEnrollAction(val){
      for (let key in this.labels) {
        this.$set(this.labels[key], "show_more", val);
      }
    }
  },
  created() {
    this.openEnrollInit();
  }
};
</script>

<style scoped lang="less">
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
  }
  100% {
    box-shadow: 0px 0px 24px 0px rgba(65, 162, 252, 1);
  }
}
.enroll-labels--container {
  padding-bottom: 70px;

  .actions{
    padding-top: 10px;
    text-align: center;

    &>div{
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .date {
    text-align: center;
    font-size: 18px;
    color: #333333;
    background-color: #f0f4f9;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-direction: row;

    .left{
      width: 10%;
    }
    .date-text{
      width: 75%;
    }
    .right{
      width: 10%;
    }
  }
  .schedule-info {
    text-align: center;
    font-size: 12px;
    padding: 3px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #c4c4c4;
  }

  .items {
    .item {
      border-radius: 6px;
      margin-top: 25px;
      /*box-sizing: border-box;*/
      font-size: 14px;
      cursor: pointer;

      &.new {
        background-color: #ff3d3d;
      }
      &.confirm {
        background-color: #fecf63;
      }
      &.done {
        background-color: #36deac;
      }
      &.canceled {
        background-color: #9946e7;
      }
      &.free {
        background-color: #f0f4f9;
      }
      &.break{
        text-align: center;
        font-size: 13px;
        color: #4F4F4F;
        text-decoration: underline;
      }
      &.progress {
        box-shadow: 0 0 0 rgba(204, 169, 44, 0.4);
        animation: pulse 1s infinite;
      }

      .head {
        border-radius: 6px;
        position: relative;
        box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.25);

        .action {
          width: 30px;
          position: absolute;
          height: 50px;
          top: 0;
          left: 4px;
          bottom: 0;
          margin: auto;

          & > div {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
        .text {
          font-size: 14px;
          color: #4f4f4f;
          text-align: center;
          font-weight: 500;
          padding: 10px 0;

          .duration_window {
            font-size: 10px;
          }
        }
      }

      .more {
        color: #333333;
        font-size: 13px;
        padding: 8px 5px 8px 15px;
        box-sizing: border-box;

        .client_services {
          white-space: nowrap; /* Запрещаем перенос строк */
          overflow: hidden; /* Обрезаем все, что не помещается в область */
          text-overflow: ellipsis; /* Добавляем многоточие */
        }
      }
    }
  }
}
</style>
